/* RESPONSIBLE TEAM: team-proactive-support */
import PredicateGroup from 'predicates/models/predicate-group';

export default PredicateGroup.extend({});
